import { render, staticRenderFns } from "./AutoCloseModal.vue?vue&type=template&id=1000a822&scoped=true"
import script from "./AutoCloseModal.vue?vue&type=script&lang=js"
export * from "./AutoCloseModal.vue?vue&type=script&lang=js"
import style0 from "./AutoCloseModal.vue?vue&type=style&index=0&id=1000a822&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1000a822",
  null
  
)

export default component.exports